/*
This action file conatin the action related to jobs , like delete job, import job, update etc
*/
import * as api from '../api';

export const JOBS_FETCH_REQUEST = 'JOBS_FETCH_REQUEST';
export const JOBS_FETCH_FAILURE = 'JOBS_FETCH_FAILURE';
export const JOBS_FETCH_SUCCESS = 'JOBS_FETCH_SUCCESS';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';

export const fetchJobs = (compId) => {
  return (dispatch, getState) => {

    dispatch({
      type: JOBS_FETCH_REQUEST
    });

    api.fetchJobs(compId).then(
      (response) => {
        // console.log("Here", response);
        dispatch({
          type: JOBS_FETCH_SUCCESS,
          jobs: response.data,
          pagination: response.pagination
        });
      },
      (error) => {
        dispatch({
          type: JOBS_FETCH_FAILURE,
          message: error.message || 'Could not fetch job.',
          error: error
        });
      }
    );
  };
};

export const JOB_POPUP_RESET = 'JOB_POPUP_RESET';
export function resetJobImportPopup(){
  return function(dispatch, getState){
      dispatch({
        type: JOB_POPUP_RESET
      });
  };
}


export const CLOSE_MODAL_POPUP_FOR_ERROR = 'CLOSE_MODAL_POPUP_FOR_ERROR';
export function closeModalPopupForError(){
  return function(dispatch, getState){
      dispatch({
        type: CLOSE_MODAL_POPUP_FOR_ERROR
      });
  };
}

export const JOB_REIMPORT_POPUP_RESET = 'JOB_REIMPORT_POPUP_RESET';
export function resetJobReimportPopup(){
  return function(dispatch, getState){
      dispatch({
        type: JOB_REIMPORT_POPUP_RESET
      });
  };
}

export const JOBS_IMPORT_REQUEST = 'JOBS_IMPORT_REQUEST';
export const JOBS_IMPORT_FAILURE = 'JOBS_IMPORT_FAILURE';
export const JOBS_IMPORT_SUCCESS = 'JOBS_IMPORT_SUCCESS';

export const importJob = (jobId,companyId,simproCompId, history) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOBS_IMPORT_REQUEST
    });

    api.importJob(jobId,companyId,simproCompId).then(
      (response) => {
        dispatch({
          type: JOBS_IMPORT_SUCCESS,
          job: response,
          tokenStatus: response.tokenStatus,
          companyData: response.companyData
        });
        //history.push(`/job/${jobId}`)
      },
      (error) => {
        sessionStorage.removeItem(jobId);
        if(error.then){
          error.then((json)=>{
            if(json && json.errcode == 401){
              dispatch({
                type: 'SIMPRO_AUTHENTICATION_FAILED'
              })
            }
            dispatch({
              type: JOBS_IMPORT_FAILURE,
              message: json.errorMessage || 'Could not import the job.',
              error: error
            });
          });
        }else{
            dispatch({
              type: JOBS_IMPORT_FAILURE,
              message: error.errorMessage || 'Could not import the job.',
              error: error
            });
        }
      }
    );
  };
};

export const JOBS_REFRESH_REQUEST = 'JOBS_REFRESH_REQUEST';
export const JOBS_REFRESH_FAILURE = 'JOBS_REFRESH_FAILURE';
export const JOBS_REFRESH_SUCCESS = 'JOBS_REFRESH_SUCCESS';

export const refreshJob = (jobId) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOBS_REFRESH_REQUEST
    });

    api.refreshJob(jobId).then(
      (response) => {
        dispatch({
          type: JOBS_REFRESH_SUCCESS,
          job: response
        });
      },
      (error) => {
        dispatch({
          type: JOBS_REFRESH_FAILURE,
          message: error.message || 'Could not import the job.',
          error: error
        });
      }
    );
  };
};

export const JOBS_DELETE_REQUEST = 'JOBS_DELETE_REQUEST';
export const JOBS_DELETE_FAILURE = 'JOBS_DELETE_FAILURE';
export const JOBS_DELETE_SUCCESS = 'JOBS_DELETE_SUCCESS';

export const deleteJob = (jobId) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOBS_DELETE_REQUEST
    });

    return api.deleteJob(jobId).then(
      (response) => {
        dispatch({
          type: JOBS_DELETE_SUCCESS,
          successMessage: 'Job deleted.'
        });
      },
      (error) => {
        dispatch({
          type: JOBS_DELETE_FAILURE,
          message: error.message || 'Could not delete the job.',
          error: error
        });
      }
    );
  };
};

export const JOB_UPDATE_REQUEST = 'JOB_UPDATE_REQUEST';
export const JOB_UPDATE_FAILURE = 'JOB_UPDATE_FAILURE';
export const JOB_UPDATE_SUCCESS = 'JOB_UPDATE_SUCCESS';

export const updateJob = (job) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_UPDATE_REQUEST
    });

    return api.updateJob(job.simpro_id, job).then(
      (response) => {
        dispatch({
          type: JOB_UPDATE_SUCCESS,
          job: response,
          successMessage: 'Job Updated.'
        });
      },
      (error) => {
        dispatch({
          type: JOB_UPDATE_FAILURE,
          error: error,
          message: error.message || 'Could not save job.'
        });
      }
    );
  };
};

export const JOB_SUCCESSMSG_RESET = 'JOB_SUCCESSMSG_RESET';
export function unsetAllertMsg(){
  return function(dispatch, getState){
      dispatch({
        type: JOB_SUCCESSMSG_RESET
      });
  };
}


export const JOB_FILE_UPLOAD_REQUEST = 'JOB_FILE_UPLOAD_REQUEST';
export const JOB_FILE_UPLOAD_SUCCESS = 'JOB_FILE_UPLOAD_SUCCESS';
export const JOB_FILE_UPLOAD_FAILURE = 'JOB_FILE_UPLOAD_FAILURE';

export const uploadJobFile = (jobId, fileType, files) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_FILE_UPLOAD_REQUEST
    });

    api.uploadJobFile(jobId, fileType, files).then(
      (response) => {
        dispatch({
          type: JOB_FILE_UPLOAD_SUCCESS,
          job: response
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'File uploaded'
        });
      },
      (error) => {
        dispatch({
          type: JOB_FILE_UPLOAD_FAILURE,
          error: error,
          message: error.message || 'Could not upload the file.'
        });
      }
    );
  };
};

export const JOB_CREATE_DOCUMENT_REQUEST = 'JOB_CREATE_DOCUMENT_REQUEST';
export const JOB_CREATE_DOCUMENT_SUCCESS = 'JOB_CREATE_DOCUMENT_SUCCESS';
export const JOB_CREATE_DOCUMENT_FAILURE = 'JOB_CREATE_DOCUMENT_FAILURE';

export const createJobDocument = (jobId,compId) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_CREATE_DOCUMENT_REQUEST
    });

    return api.createJobDocument(jobId,compId).then(
      (response) => {
        dispatch({
          type: JOB_CREATE_DOCUMENT_SUCCESS,
          job: response
        });
      },
      (error) => {

        if(error.then){
          
            error.then((json)=>{
              if( error && error.code && error.code === 503 ) {
                fetchJobWithDocumentBeingCreated(dispatch, jobId);
              }
              else {
                dispatch({
                  type: JOB_CREATE_DOCUMENT_FAILURE,
                  message: json.errorMessage || 'Could not create the document.',
                  mergeFiles : json.mergeFileNames,
                  errorType: json.type,
                  errorFileName: json.fileName,
                  error: error,
                });
                // dispatch({
                //   type: NOTIFICATION_ADD,
                //   text: json.errorMessage || 'Could not create the document.',
                //   msgtype: 'danger'
                // });
              }
          });

        }else{
            if( error && error.code && error.code === 503 ) {
              fetchJobWithDocumentBeingCreated(dispatch, jobId);
            }
            else {
              dispatch({
                type: JOB_CREATE_DOCUMENT_FAILURE,
                message: error.message || 'Could not create the document.',
                errorType: error.type,
                errorFileName: error.fileName,
                mergeFiles : error.mergeFileNames,
                error: error
              });
              // dispatch({
              //   type: NOTIFICATION_ADD,
              //   text: 'Could not create the document.',
              //   msgtype: 'danger'
              // });
            }
        }
        return error  
    });
  };
};

export const JOB_STATUS_DOCUMENT_FAIL = 'JOB_STATUS_DOCUMENT_FAIL';
export const JOB_STATUS_DOCUMENT_SUCCESS = 'JOB_STATUS_DOCUMENT_SUCCESS';

export const statusJob = (jobId,compId) => {
  return (dispatch, getState) => {
    // dispatch({
    //   type: JOB_STATUS_DOCUMENT_REQUEST
    // });

    return api.fetchJobStatus(jobId,compId).then(
      (response) => {
        dispatch({
          type: JOB_STATUS_DOCUMENT_SUCCESS,
          job: response,
          successMessage: 'Job status fetch.'
        });
      },
      (error) => {
        dispatch({
          type: JOB_STATUS_DOCUMENT_FAIL,
          error: error,
          message: error.message || 'Could not fetch status.'
        });
      }
    );
  };
};

export const JOB_STATUS_DOCUMENT_RESET = 'JOB_STATUS_DOCUMENT_RESET';
export const statusJobReset = () => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_STATUS_DOCUMENT_RESET
    });
  };
};

const fetchJobWithDocumentBeingCreated = (dispatch, jobId) => {
  api.fetchJob(jobId).then(
    (job) => {
      // Check if the job has been completed and then either dispatch
      // JOB_CREATE_DOCUMENT_SUCCESS or a setInterval
      if( job.pdf_request_process_status && job.pdf_request_process_status.step === 'finished') {
        dispatch({
          type: JOB_CREATE_DOCUMENT_SUCCESS,
          job: job
        });
      }
      else if( job.pdf_request_process_status && job.pdf_request_process_status.step === 'error') {
        dispatch({
          type: JOB_CREATE_DOCUMENT_FAILURE,
          message: 'Could not create the document.',
        });
      }
      else {
        dispatch({
          type: JOB_CREATE_DOCUMENT_SUCCESS,
          job: job
        });
        window.setTimeout(function() {
          fetchJobWithDocumentBeingCreated(dispatch, jobId);
        }, 2000);
      }
    },
    (error) => {
    }
  );
};


export const COMPANIES_API_REQUEST = 'COMPANIES_API_REQUEST';
export const COMPANIES_API_FAILURE = 'COMPANIES_API_FAILURE';
export const COMPANIES_API_SUCCESS = 'COMPANIES_API_SUCCESS';

export function getCompaniesFromApi(companyid) {
  
  return function (dispatch, getState) {
    dispatch({
      type: COMPANIES_API_REQUEST
    });
    api.getCompaniesFromApi(companyid).then(
      (response) => {
        dispatch({
          type: COMPANIES_API_SUCCESS,
          apiAuthorize: response
        });
      },
      (error) => {
        dispatch({
          type: COMPANIES_API_FAILURE,
          text: 'Error get api companies request',
          msgtype: 'danger'
        });
      }
    );
  };
}


export const JOBS_REIMPORT_REQUEST = 'JOBS_REIMPORT_REQUEST';
export const JOBS_REIMPORT_FAILURE = 'JOBS_REIMPORT_FAILURE';
export const JOBS_REIMPORT_SUCCESS = 'JOBS_REIMPORT_SUCCESS';

export const reimportJob = (jobId,companyId,simproCompId, TokenStatus) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOBS_REIMPORT_REQUEST
    });

    api.reimportJob(jobId,companyId,simproCompId, TokenStatus).then(
      (response) => {
        dispatch({
          type: JOBS_REIMPORT_SUCCESS,
          job: response,
          tokenStatus: response.tokenStatus,
          companyData: response.companyData
        });
      },
      (error) => {
        sessionStorage.removeItem(jobId);
        if(error.then){
          
          error.then((json)=>{
            if(json && json.errcode == 401){
              dispatch({
                type: JOBS_REIMPORT_FAILURE,
                message: json.errorMessage || 'Could not re-import the job.',
                error: error
              });
              dispatch({
                type: 'SIMPRO_AUTHENTICATION_FAILED'
              })
            }else{
              dispatch({
                type: JOBS_REIMPORT_SUCCESS,
                message: json.errorMessage || 'Could not re-import the job.',
                error: error
              });
            } 
          });
        }else{
            dispatch({
              type: JOBS_REIMPORT_FAILURE,
              message: error.errorMessage || 'Could not re-import the job.',
              error: error
            });
        }
      }
    );
  };
};

export const SEND_TO_SIMPRO_REQUEST = 'SEND_TO_SIMPRO_REQUEST';
export const SEND_TO_SIMPRO_FAILURE = 'SEND_TO_SIMPRO_FAILURE';
export const SEND_TO_SIMPRO_SUCCESS = 'SEND_TO_SIMPRO_SUCCESS';

export const sendToSimpro = (companyId, jobId, simpro_company_id, createdManualUrl) => {
  return (dispatch, getState) => {
    dispatch({
      type: SEND_TO_SIMPRO_REQUEST
    });

    api.sendToSimpro(companyId, jobId, simpro_company_id, createdManualUrl).then(
      (response) => {
        dispatch({
          type: SEND_TO_SIMPRO_SUCCESS,
          tokenStatus: response.tokenStatus,
          companyData: response.companyData
        });
        dispatch({
          type: NOTIFICATION_ADD,
          text: 'Manual pdf uploaded to simPRO successfully.',
          msgtype: 'success',
          tokenStatus: response.tokenStatus
        });
      },
      (error) => {
        if(error.then){
          
          error.then((json)=>{
            dispatch({
              type: SEND_TO_SIMPRO_SUCCESS,
              message: json.errorMessage || 'Manual upload to simPRO failed.',
              error: error
            });
            dispatch({
                type: NOTIFICATION_ADD,
                text: 'Manual upload to simPRO failed.',
                msgtype: 'danger'
              });
          });
        }else{
            dispatch({
              type: SEND_TO_SIMPRO_FAILURE,
              message: error.errorMessage || 'Manual upload to simPRO failed.',
              error: error
            });
            dispatch({
                type: NOTIFICATION_ADD,
                text: 'Manual upload to simPRO failed.',
                msgtype: 'danger'
              });
        }
      }
    );
  };
};


export const FIND_ALL_ENCRYPTED_FILES_REQUEST = 'FIND_ALL_ENCRYPTED_FILES_REQUEST';
export const FIND_ALL_ENCRYPTED_FILES_FAILURE = 'FIND_ALL_ENCRYPTED_FILES_FAILURE';
export const FIND_ALL_ENCRYPTED_FILES_SUCCESS = 'FIND_ALL_ENCRYPTED_FILES_SUCCESS';

export const findAllEncryptedFiles = (files, cloudConvertRes, type) => {
  return (dispatch, getState) => {
    dispatch({
      type: FIND_ALL_ENCRYPTED_FILES_REQUEST
    });

    api.findAllEncryptedFiles(files, cloudConvertRes, type).then(
      (response) => {
        dispatch({
          type: FIND_ALL_ENCRYPTED_FILES_SUCCESS,
          files: response
        });
      },
      (error) => {
        dispatch({
          type: FIND_ALL_ENCRYPTED_FILES_FAILURE,
        });
      }
    );
  };
};

export function cancelSimproUpdate (){
  return (dispatch, getState) => {
    dispatch({
      type: 'SIMPRO_AUTHENTICATION_FAILED'
    });
  };
}
export const SIMPRO_UPDATE_DETAILS_REQUEST = 'SIMPRO_UPDATE_DETAILS_REQUEST';
export const SIMPRO_UPDATE_DETAILS_FAILURE = 'SIMPRO_UPDATE_DETAILS_FAILURE';
export const SIMPRO_UPDATE_DETAILS_SUCCESS = 'SIMPRO_UPDATE_DETAILS_SUCCESS';

export const updateSimproDetails = (username,password, compId, backToJob) => {
  return (dispatch, getState) => {
    dispatch({
      type: SIMPRO_UPDATE_DETAILS_REQUEST
    });
    api.updateSimproDetails(username,password, compId).then(
      (response) => {
        dispatch({
          type: SIMPRO_UPDATE_DETAILS_SUCCESS,
          simproDetails: response.company,
        });
        backToJob();
      },
      (error) => {
        if(error.then){
          
          error.then((json)=>{
              dispatch({
                type: SIMPRO_UPDATE_DETAILS_FAILURE,
                message: json.errorMessage || 'Could not update the details.',
                error: error
              });
            
          });
        }else{
            dispatch({
              type: SIMPRO_UPDATE_DETAILS_FAILURE,
              message: error.errorMessage || 'Could not update the details.',
              error: error
            });
        }
      }
    );
  };
};
export const SEARCH_JOB_SET_REQUEST= 'SEARCH_JOB_SET_REQUEST'
export const SEARCH_JOB_SUCCESS= 'SEARCH_JOB_SUCCESS'
export const SEARCH_JOB_FAILURE= 'SEARCH_JOB_FAILURE'

export function searchJob(search,id,activePage){

	return function(dispatch, getState){

	    dispatch({
	      type: SEARCH_JOB_SET_REQUEST
	    });
	    return api.searchJob(search,id,activePage).then(
	    	(response) => {
		        dispatch({
		          type: SEARCH_JOB_SUCCESS,
		          alljobs: response.jobs,
              allJobsCount: response.count
		        });
		      },
		      (error) => {
		        dispatch({
		          type: SEARCH_JOB_FAILURE,
		          error: error,
		          message: error.message || 'Could not search job'
		        });
		      }
	    );
	};
}


// WEBPACK FOOTER //
// ./src/Actions/jobs.js